<template>
  <div id="login-bg">
    <div class="row" ref="parent">
      <div class="col-sm-4">
        <div class="image-wrap">
          <img class="asset" :src="imagesRandom[0]" />
        </div>
        <div class="image-wrap">
          <video class="asset" muted loop autoplay>
            <source :src="videosRandom[0]" />
          </video>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="image-wrap">
          <img class="asset" :src="imagesRandom[1]" />
        </div>
        <div class="image-wrap">
          <img class="asset" :src="imagesRandom[2]" />
        </div>
      </div>
      <div class="col-sm-4">
        <div class="image-wrap">
          <video class="asset" muted loop autoplay>
            <source :src="videosRandom[1]" />
          </video>
        </div>
        <div class="image-wrap">
          <img class="asset" :src="imagesRandom[3]" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
export default {
  name: "LoginBackground",
  data() {
    return {
      allImgs: [
        "/images-login/1.png",
        "/images-login/2.png",
        "/images-login/3.png",
        "/images-login/4.png",
        "/images-login/5.png",
        "/images-login/6.png",
        "/images-login/7.png",
        "/images-login/8.png",
        "/images-login/9.png",
        "/images-login/10.png",
        "/images-login/11.png",
        "/images-login/12.png",
        "/images-login/13.png",
      ],
      allVideos: [
        "/videos-login/1.mp4",
        "/videos-login/2.mp4",
        "/videos-login/3.mp4",
        "/videos-login/4.mp4",
        "/videos-login/5.mp4",
        "/videos-login/6.mp4",
        "/videos-login/7.mp4",
        "/videos-login/8.mp4",
        "/videos-login/9.mp4",
      ],
    };
  },
  methods: {
    handlMove(e) {
      this.columns.forEach((item, key) => {
        const cells = item.querySelectorAll(".image-wrap");
        cells.forEach((cell, index) => {
          const positions = cell.getBoundingClientRect();

          gsap.to(cell.querySelector(".asset"), {
            x:
              (positions.left -
                (e.clientX - window.innerWidth / 2) -
                window.innerWidth / 2) *
              ((key + 1) * (index + 1) * 0.025),
            y:
              (positions.top -
                (e.clientY - window.innerHeight / 2) -
                window.innerHeight / 2) *
              ((key + 1) * (index + 1) * 0.025),
            duration: 1.75,
            ease: "expo.out",
          });
        });
      });
    },
  },
  mounted() {
    this.columns = this.$refs.parent.querySelectorAll(".col-sm-4");
    window.addEventListener("mousemove", this.handlMove);
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.handlMove);
  },
  computed: {
    imagesRandom() {
      const result = this.allImgs.slice(0, 4).map(function () {
        return this.splice(Math.floor(Math.random() * this.length), 1)[0];
      }, this.allImgs.slice());

      return result;
    },
    videosRandom() {
      const result = this.allVideos.slice(0, 2).map(function () {
        return this.splice(Math.floor(Math.random() * this.length), 1)[0];
      }, this.allVideos.slice());

      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
#login-bg {
  position: absolute;
  width: 110%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
  .row {
    position: relative;
    height: 110%;
    top: -5vh;
  }
  .col-sm-4 {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .image-wrap {
    position: relative;
    width: 100%;
    height: 50%;
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      width: 100%;
    }
    video {
      display: block;
      width: 100%;
    }
  }
}
</style>